import { render, staticRenderFns } from "./Simulateur.vue?vue&type=template&id=70bfac45&scoped=true&"
import script from "./Simulateur.vue?vue&type=script&lang=js&"
export * from "./Simulateur.vue?vue&type=script&lang=js&"
import style0 from "./Simulateur.vue?vue&type=style&index=0&id=70bfac45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bfac45",
  null
  
)

export default component.exports